import ForbiddenMessagePanel from './ForbiddenMessagePanel'

export default ForbiddenMessagePanel
